import { CompanyInfos } from "#modules/company/view/CompanyInfos";
import { useCompany } from "#modules/company/view/useCompany";
import { useTeam } from "#modules/users/view/useTeam";
import { PageLayout } from "#shared/layouts/PageLayout";
import { ROUTES } from "#shared/routes";
import { Alert } from "#shared/view/components/Alert";
import { Loader } from "#shared/view/components/Loader";

export const InformationsSettingsPage = () => {
  const { company, isLoading } = useCompany();
  const { team } = useTeam();

  if (isLoading) {
    return <Loader />;
  }

  if (!company) {
    return (
      <Alert color="red" title="Un problème est survenu">
        Un problème est survenu à la récupération des informations de l'entreprise
      </Alert>
    );
  }

  return (
    <PageLayout
      withBorder
      title="Informations sur mon entreprise"
      titleIcon="home"
      subtitle="Retrouvez et éditez toutes les informations sur votre entreprise."
      breadcrumbs={breadcrumbs}
      fullWidth
    >
      <CompanyInfos company={company} team={team} />
    </PageLayout>
  );
};

const breadcrumbs = [
  {
    label: "Mon entreprise",
    href: "#",
  },
  {
    label: "Informations",
    href: ROUTES.partnerSettingsInformations,
  },
];
